export default __webpack_public_path__ + "static/media/simple.0722f73b.svg";